import React from 'react';

import Text from '@zenbusiness/zui/Text';

import * as Footer from './LegalFooter.style';

/**
 * Application footer component that displays footer content
 * @returns {React.ReactElement} The AppFooter component
 */
export default function LegalFooter() {
  return (
    <Footer.LegalFooterRoot>
      <Text color="tertiary" size="xs">
        Velo responses can contain errors. Submissions will be used to provide personalized results.
        All data used in compliance with our Privacy Policy.
      </Text>
    </Footer.LegalFooterRoot>
  );
}
